module.exports = __webpack_public_path__ + "static/media/media3.2531b593.png";